import menu from './ja-JP/menu';
import pages from './ja-JP/pages';

export default {
  'navBar.lang': '言語',
  ...menu,
  ...pages,
};
